import React, { useEffect, useRef, useState } from 'react'
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../../components/BaseConfig';
import Button2 from '../../../../components/general/button2';
import { UIProperties } from '../UIProperties';

import "./core-return-to-main-menu-ui.css"
import { AnimationModal, AnimationModalType } from '../../../UI/Animation/animation-modal';
import { AnimationState } from '../../../UI/Animation/animation-base';
import CorePopUp from './core-pop-up';
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../../../misc/tools';

const CoreReturnToMainMenuUI = (props: UIProperties<CoreReturnToMainMenuUIConfig>) => {
	const [animation, setAnimation] = useState(new AnimationModal(AnimationModalType.reveal));
	const modalRoot = useRef(null);
	const modalContainer = useRef(null);
	useEffect(() => {
		animation.updateProps({
			modalRoot: modalRoot.current,
			modalContainer: modalContainer.current,
			// backgroundContentRoot: document.getElementsByTagName('video')[0]
		});
	}, [])
	return (
		<div className={"modal-disable-select center-element return-to-main-menu-ui-container"} style={{
			zIndex: '10000'
		}}>
			<div ref={modalRoot} className={'black-overlay ' + animation.getModalBackgroundOverlayInitialClass()} style={{width: '100%', height: '100%', position: 'absolute'}}>

			</div> 
			<div ref={modalContainer} className={'return-to-main-menu-ui-inner-container ' + animation.getModalContainerInitialClass()}>
				<CorePopUp title='Return to Main Menu' onRenderContent={() => {
					return (
						<div className='return-to-main-menu-ui-content'>
							<p className='small-text white-text' style={{
								textAlign: 'center',
								position: 'absolute',
								top: '-20px',
								width: '94%',
								...getGlobalTextSizeStyle(TextHtmlTagType.p)
							}} >
								Are you sure you want to return to the main menu?
								<br/>
								<br/>
								Any progress that has not been saved will be lost.
							</p>
							<div className='return-to-main-menu-ui-content-cancel-bttn-container'>
								<Button2 idFor508={props.parameters.topId} width= '100%'
									height= '100%'
									onClick= {props.parameters.onGoToMainMenuClicked}
									hoverBgColor={constants.design.hoverColor2}
									onRenderContent= {() => {
										return (
											<div className='return-to-main-menu-ui-content-btn center-element'>
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text return-to-main-menu-ui-content-btn-text black-text'>Go To Main Menu</p>
											</div>
										)
									}}
									isSelected= {false}
									ariaLabel= 'Go To Main Menu'></Button2>
							</div>
							<div className='return-to-main-menu-ui-content-confirm-bttn-container'>
								<Button2 idFor508={props.parameters.bottomId} width= '100%'
									height= '100%'
									hoverBgColor={constants.design.hoverColor2}
									onClick= {() => {
										animation.setState(AnimationState.Out, () => {
											props.parameters.onCancelClicked();
										})
									}}
									onRenderContent= {() => {
										return (
											<div>
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text return-to-main-menu-ui-content-btn-confirm-text center-element-vertical black-text'>Cancel</p>
											</div>
										)
									}}
									isSelected= {false}
									ariaLabel= 'Cancel'></Button2>
							</div>
						</div>
					);
				}}></CorePopUp>
			</div>
		</div>
	);

};

export interface CoreReturnToMainMenuUIConfig extends BaseConfig {
	topId: string;
	bottomId: string;
	onGoToMainMenuClicked: () => void;
	onCancelClicked: () => void;
}

export default CoreReturnToMainMenuUI;